import { useEffect, useState } from 'react';
import { api, MeResponse } from './api';
import { AuthScreen } from './auth';
import { Dashboard } from './Dashboard';

type State =
  | { kind: 'loading' }
  | { kind: 'anonymous' }
  | { kind: 'user'; username: string };

export function App() {
  const [state, setState] = useState<State>({ kind: 'loading' });

  useEffect(() => {
    api.get<MeResponse>('/api/me').then((me) => {
      if (me.kind === 'user') setState({ kind: 'user', username: me.username });
      else setState({ kind: 'anonymous' });
    }).catch(() => setState({ kind: 'anonymous' }));
  }, []);

  if (state.kind === 'loading') {
    return <div className="center"><div className="muted">loading…</div></div>;
  }
  if (state.kind === 'anonymous') {
    return <AuthScreen onAuthed={(username) => setState({ kind: 'user', username })} />;
  }
  return (
    <Dashboard
      username={state.username}
      onLogout={() => setState({ kind: 'anonymous' })}
    />
  );
}
